import './back-button.scss'

import React from 'react'
import { BackArrowIcon } from '@entur/icons'
import { useNavigate } from 'react-router-dom'
import { useHotkeys } from 'react-hotkeys-hook'
import { Link } from '../link/link'

type BackButtonProps = {
  disabled?: boolean
}
export const BackButton: React.FC<BackButtonProps> = ({ disabled }) => {
  const navigate = useNavigate()

  const goBack = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e?.preventDefault()
    if (!disabled) navigate('/')
  }

  useHotkeys(
    'alt+backspace',
    (event) => {
      event.preventDefault()
      goBack()
    },
    [disabled]
  )

  return (
    <Link data-cy="back-link" className="back-link" disabled={disabled} to="/" onClick={goBack}>
      <BackArrowIcon id="back-link-icon" />
      <span>Tilbake til søk</span>
    </Link>
  )
}
